import React from 'react';

import { ContentState, DraftDecorator } from 'draft-js';

export const findCustomClassEntities: DraftDecorator['strategy'] = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges((character) => {
    const entityKey = character.getEntity();
    return entityKey !== null && contentState.getEntity(entityKey).getType() === 'CUSTOM_CLASS';
  }, callback);
};

export const CustomClassDecorator: DraftDecorator['component'] = (props: {
  contentState: ContentState;
  entityKey: string;
  children: React.ReactNode;
}) => {
  const { entityKey, contentState, children } = props;
  const entity = contentState.getEntity(entityKey);
  const { className } = entity.getData();

  return <span className={className}>{children}</span>;
};
